<template>
  <div
    id="canvas-container-animation-winterbonusjagd-winter-bg"
    ref="canvascontainer"
  ></div>
</template>

<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";
import { Spine } from "pixi-spine";

export default {
  name: "AnimationSpineWinterbonusjagdWinnerBg",
  mixins: [AnimationSpineBaseFunctions],
  props: {
    loop: {
      type: Boolean,
      default: true,
    },
    run: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      unsubscribeEvents: [],
      version: 1,
      destroyApp: false,
    };
  },

  watch: {
    run: function (newVal) {
      if (newVal) {
        this.destroyApp = true;
        this.play();
      }
    },
  },
  beforeDestroy() {
    //destroy event listeners
    for (let i = 0; i < this.unsubscribeEvents.length; i++) {
      this.unsubscribeEvents[i]();
    }

    this.destroyApp = true;
  },
  mounted: function () {
    this.play();
  },

  methods: {
    async play() {
      const canvasEl = document.getElementById(
        "canvas-animation-winterbonusjagd-winter-bg"
      );

      const assets = [
        [
          "winterbonusjagd-kingspass",
          "/assets/spines/events/winterbonusjagd/winterbonus-winscreen.json?v=" +
            this.version,
        ],
      ];
      const options = {
        width: 1390.17,
        height: 825.67,
        antialias: true,
        backgroundAlpha: 0,
        autoResize: true,
      };

      const app = await this.createCanvas(
        options,
        assets,
        this.$refs.canvascontainer.id
      );
      app.view.id = "canvas-animation-winterbonusjagd-winter-bg";

      app.ticker.add(() => {
        if (this.destroyApp) {
          this.destroyApp = false;
          this.destroyAll(app);
        }
      });

      const setup = (loader, res) => {
        let spineData = this.getSpineData(res);

        spineData.forEach((data) => {
          const spine = new Spine(data);

          // set the position
          spine.x = app.screen.width / 2;
          spine.y = app.screen.height / 2;

          //set scale
          spine.scale.set(0.84);

          //add spine to stage
          app.stage.addChild(spine);

          //run animation
          let animation = this.getAnimationByName(data, "main");
          spine.state.setAnimation(0, animation.name);

          //show first frame when not running
          if (!this.run) {
            spine.state.getCurrent(0).animationEnd = 0;
            return;
          }

          //set animation end
          spine.state.getCurrent(0).animationEnd = animation.duration;

          // Detach event listeners
          this.unsubscribeEvents.push(() => {
            spine.state.getCurrent(0).onEvent = null;
          });

          //add loop
          if (this.loop) {
            spine.state.getCurrent(0).loop = true;
          }
        });
      };

      app.loader.load(setup);
      app.loader.onComplete.add(() => {
        this.$emit("done");
      });

      //remove old chest when new loaded
      app.loader.onComplete.add(() => {
        if (canvasEl) {
          this.removePrevCanvas(this.$refs.canvascontainer.id);
        }
      });
    },
  },
};
</script>

<style lang="scss">
#canvas-container-animation-winterbonusjagd-winter-bg {
  pointer-events: none;

  #canvas-animation-winterbonusjagd-winter-bg {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: 0;
  }
}
</style>
